{
	"analyzing": "Analyzing photos to learn your editing style. This may take a few moments.",
	"ariaCancelCreation": "Cancel AI Style Creation",
	"creating": "Creating your AI Style...",
	"failedToCreateStyleFrom": "Failed to create style from files.",
	"failedToCreateStyleFrom2": "Failed to create style from Collection.",
	"failedToFetchPhotosFrom": "Failed to fetch photos from Collection."
}
